// extracted by mini-css-extract-plugin
export default {"primaryColor":"#1890ff","backColor":"#f0f2f5","buttonSpacing":"8px","textButtonSpacing":"4px","carTree":"carTreeV2_carTree__elJiU","title":"carTreeV2_title__Gudnj","filterIcon":"carTreeV2_filterIcon__IcSNE","tree":"carTreeV2_tree__8TYud"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"primaryColor\":\"#1890ff\",\"backColor\":\"#f0f2f5\",\"buttonSpacing\":\"8px\",\"textButtonSpacing\":\"4px\",\"carTree\":\"carTreeV2_carTree__elJiU\",\"title\":\"carTreeV2_title__Gudnj\",\"filterIcon\":\"carTreeV2_filterIcon__IcSNE\",\"tree\":\"carTreeV2_tree__8TYud\"}";
        // 1793842504420
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  